import { useWebAppGetCompositionsDetailById } from '@mi-front/api-v2';

/**
 * Fetches composition detail by id (BFF).
 */
export function useCompositionQuery(compositionId: string) {
  return useWebAppGetCompositionsDetailById(compositionId, {
    query: {
      enabled: !!compositionId,
    },
  });
}
